import styled from "styled-components"

import { spacing, colors, borderRadius } from "@izettle/otto"

export const SelectActionsWrapper = styled.div`
  display: flex;
  outline: none;
  background: ${colors.background.default};
  border: none;
  min-height: fit-content;
  flex-direction: column;
  padding: ${spacing.xSmall};
  border-top: 1px solid ${colors.border.divider};
  position: sticky;
  bottom: 0;
  border-bottom-left-radius: ${borderRadius.large};
  border-bottom-right-radius: ${borderRadius.large};
`
